import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useEffect, useState } from 'react';
import { TextField } from '../form';
import { ItemWithLabel } from '../utils';
import {
  Dialog,
  DialogActions,
  DialogButton,
  DialogContent,
  ModalInstance,
} from './utils';

const tagDialog = new ModalInstance<TagOptions>('TagDialog');
const NEW_TAG = '{NEW_TAG}';

export default function TagDialog() {
  const [options] = tagDialog.useOptions();

  const [selectedOption, setSelectedOption] = useState('');
  const [newTag, setNewTag] = useState('');

  useEffect(() => setSelectedOption(options?.selected || ''), [options]);
  useEffect(() => setNewTag(''), [options]);

  const isCreatingNewTag = selectedOption === NEW_TAG;

  function onOkClick() {
    tagDialog.close(isCreatingNewTag ? newTag : selectedOption);
  }

  if (!options) {
    return null;
  }

  return (
    <Dialog
      onClose={() => tagDialog.close('cancel')}
      title={options.title || ''}
    >
      <DialogContent>
        <FormControl>
          <RadioGroup
            onChange={(e) => setSelectedOption(e.target.value)}
            value={selectedOption || ''}
          >
            <FormControlLabel control={<Radio />} label="Not Set" value="" />

            {options.options.map((option) => (
              <FormControlLabel
                control={<Radio />}
                key={option.value}
                label={option.label}
                value={option.value}
              />
            ))}

            <FormControlLabel
              control={<Radio />}
              label={
                <>
                  <Box sx={{ mt: 1 }}>
                    {options.createNewTitle || 'Create New Tag'}
                  </Box>
                  {isCreatingNewTag && (
                    <TextField
                      autoFocus
                      onChange={(e) => setNewTag(e.target.value)}
                      sx={{ mt: 0 }}
                      value={newTag}
                    />
                  )}
                </>
              }
              sx={{ alignItems: 'flex-start' }}
              value={NEW_TAG}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <DialogButton
          disabled={isCreatingNewTag && !newTag}
          onClick={onOkClick}
          title="OK"
        />
        <DialogButton
          onClick={() => tagDialog.close('cancel')}
          title="Cancel"
          type="secondary"
        />
      </DialogActions>
    </Dialog>
  );
}

export function showTagDialog(options: TagOptions): Promise<string> {
  return tagDialog.show(options);
}

export interface TagOptions {
  createNewTitle?: string;
  onDelete?: (tagName: string) => void;
  onRename?: (oldTagName: string, newTagName: string) => void;
  options: ItemWithLabel[];
  selected?: string;
  title?: string;
}
